import axios from "axios";


function configureCityAPI(options) {
    const apiUrl = `${options.baseUrl}/city`;

    return {
        async getCities(postalCode) {
            const response = await axios.get(`${apiUrl}/get-cities`, {
                params: {"postal-code": postalCode}
            });
            return response.data.content;
        }
    };
}

export { configureCityAPI };